// src/components/Modals/UserGalleryModal.js
import React, { useEffect, useState } from "react";
import { Modal, Button, Spin, message } from "antd";
import {
  LeftOutlined,
  RightOutlined,
  DeleteOutlined,
  StarOutlined,
} from "@ant-design/icons";
import styles from "./UserGalleryModal.module.css";

const UserGalleryModal = ({ visible, onClose, userId, placeId }) => {
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const clientId = userId?.replace("USER#", "");

  useEffect(() => {
    if (!visible || !clientId) return;
    setLoading(true);

    fetch(
      "https://wg8x98quyf.execute-api.eu-west-1.amazonaws.com/PortalAPI/unrecognized-images",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ client_id: clientId }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.statusCode === 200) {
          setImages(data.body || []);
        } else {
          message.error("Ошибка загрузки изображений");
        }
      })
      .catch(() => message.error("Ошибка соединения"))
      .finally(() => setLoading(false));
  }, [visible, clientId]);

  const handleDelete = async (file_name_raw) => {
    const file_name = `faces-user-id/${clientId}/${file_name_raw}`;
    try {
      const response = await fetch(
        "https://k3yidf1b5l.execute-api.eu-west-1.amazonaws.com/default/dev-portal-disassociate-faces-lambda",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ file_name }),
        }
      );
      if (response.ok) {
        message.success("Изображение удалено");
        setImages((prev) =>
          prev.filter((img) => img.file_name !== file_name_raw)
        );
        setCurrentIndex((prev) => Math.max(0, prev - 1));
      } else {
        message.error("Ошибка удаления");
      }
    } catch {
      message.error("Ошибка соединения при удалении");
    }
  };

  const handleMakeMain = async (file_name) => {
    try {
      const res = await fetch(
        "https://wg8x98quyf.execute-api.eu-west-1.amazonaws.com/PortalAPI/choose-main-image",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            place_id: placeId,
            user_id: clientId,
            file_name,
          }),
        }
      );
      const data = await res.json();
      if (res.ok) {
        message.success("Главное фото установлено");
      } else {
        throw new Error(data.message || "Ошибка установки");
      }
    } catch (err) {
      message.error("Ошибка при установке главного фото");
    }
  };

  const currentImage = images[currentIndex];

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={900}
      title={<div className={styles.user_modal_title}>Галерея фотографий</div>}
    >
      {loading ? (
        <Spin />
      ) : (
        <div className={styles.gallery_wrapper}>
          {/* Left: Main Image */}
          <div className={styles.gallery_main_image}>
            {currentImage ? (
              <>
                <div className={styles.gallery_nav_buttons}>
                  <Button
                    onClick={() =>
                      setCurrentIndex((prev) => Math.max(prev - 1, 0))
                    }
                    icon={<LeftOutlined />}
                    disabled={currentIndex === 0}
                  />
                  <Button
                    onClick={() =>
                      setCurrentIndex((prev) =>
                        Math.min(prev + 1, images.length - 1)
                      )
                    }
                    icon={<RightOutlined />}
                    disabled={currentIndex === images.length - 1}
                  />
                </div>

                <div className={styles.gallery_image_container}>
                  <img src={currentImage.presigned_url} alt="Фото" />
                </div>

                <div className={styles.gallery_controls}>
                  <span>Просмотр фотографий</span>
                  <span>Все фото: {images.length}</span>
                  <Button
                    type="primary"
                    icon={<StarOutlined />}
                    onClick={() => handleMakeMain(currentImage.file_name)}
                  >
                    Сделать главной
                  </Button>
                </div>
              </>
            ) : (
              <div>Нет изображений</div>
            )}
          </div>

          {/* Right: Thumbnails */}
          <div className={styles.gallery_thumbnail_wrapper}>
            {images.map((img, i) => (
              <div
                key={img.file_name}
                className={`${styles.gallery_thumbnail} ${
                  i < 4 ? "starred" : ""
                }`}
              >
                <img
                  src={img.presigned_url}
                  alt="thumbnail"
                  onClick={() => setCurrentIndex(i)}
                />
                <Button
                  shape="circle"
                  icon={<DeleteOutlined />}
                  size="small"
                  onClick={() => handleDelete(img.file_name)}
                  className={styles.contact_delete}
                  style={{ position: "absolute", top: -6, right: -6 }}
                />
              </div>
            ))}
          </div>
        </div>
      )}
      <div className={styles.modal_footer}>
        <Button onClick={onClose}>Закрыть</Button>
      </div>
    </Modal>
  );
};

export default UserGalleryModal;
